<template>
    <div class="dropdown text-xs" v-click-outside="close">
        <Button :id="dropdownId" :color="color" :icon="icon" @click="toggleShow" :small="small">
            <span v-if="title">{{ title }}</span>
            <Icon icon="caret-down" :class="{ 'ms-1': title }" />
        </Button>
        <ul :aria-labelledby="dropdownId"
            class="dropdown-menu text-xs"
            :class="{
                'show': show,
                'dropdown-menu-end': position === 'right',
                'dropdown-menu-center': position === 'center'
            }">
            <slot></slot>
        </ul>
    </div>
</template>

<script>
    import Button from '../Button'

    export default {
        name: 'Dropdown',
        components: {
            Button
        },
        props: {
            icon: [ String, Array ],
            title: String,
            color: {
                type: String,
                default: 'light'
            },
            small: {
                type: Boolean,
                default: false
            },
            position: {
                type: String,
                default: 'left',
                validator: function (value) {
                    return ['right', 'left', 'center'].includes(value)
                }
            }
        },
        data() {
            return {
                dropdownId: 'dropdown-' + ( Math.floor(Math.random() * 99999) + 1 ),
                show: false
            }
        },
        methods: {
            toggleShow() {
                this.show = !this.show
            },
            close() {
                this.show = false
            }
        }
    }
</script>
